import React from 'react';
import s from './SettingsPopover.scss';
import { Menu } from '../Menu/Menu';
import { SpeedSelector } from '../SpeedSelector';
import { useSettings } from '../../providers/SettingsProvider';
import { useView, View } from '../../providers/ViewProvider';
import { FadeIn } from '../FadeIn/FadeIn';
import { QualitySelector } from '../QualitySelector';
export const SettingsPopover = () => {
  const {
    config: {
      fontFamily
    }
  } = useSettings();
  const {
    view
  } = useView();
  return /*#__PURE__*/React.createElement(FadeIn, null, /*#__PURE__*/React.createElement("div", {
    "data-hook": "wix-vod-playable-settings-popover",
    className: s.popover,
    style: {
      fontFamily
    }
  }, view === View.Menu ? /*#__PURE__*/React.createElement(Menu, null) : null, view === View.Speed ? /*#__PURE__*/React.createElement(SpeedSelector, null) : null, view === View.Quality ? /*#__PURE__*/React.createElement(QualitySelector, null) : null, view === View.Subtitles ? /*#__PURE__*/React.createElement("h1", null, "Subtitles") : null));
};
export function createSettingsPopoverContainer() {
  const element = document.createElement('div');
  element.className = s.root;
  element.setAttribute('data-hook', 'wix-vod-playable-settings-popover-container');
  const updatePosition = isInFullScreen => {
    element.classList.toggle(s.fullScreen, isInFullScreen);
  };
  return {
    element,
    updatePosition
  };
}
//# sourceMappingURL=SettingsPopover.js.map